import { EnergySelectionStepModel } from '@/models';

export interface EnergyState {
  energySelectionStepInfo: EnergySelectionStepModel | null;
}

export const InitialState: EnergyState = {
  energySelectionStepInfo: null,
};
